import { Box, ButtonBase, Typography } from '@mui/material';
import DocumentIcon from '../../../../../../../../../../../../../../icons/DocumentIcon';
import useTeceoStyles from '../../../../../../../../../../../../../../useTeceoStyles';
import { openLinkInNewTab } from '../../../../../../../../../../../../../../utils/openLinkInNewTab';
import { isFileMessageType } from '../../../../../../../../../../../../contexts/chatSocket/reducer/chatSocketReducer.utils';
import TextMessage from '../TextMessage/TextMessage';
import { useFileMessagesStyles } from './fileMessage.styles';
import { FileMessageProps } from './fileMessage.types';

const FileMessage = ({ message, isMessageOfUser }: FileMessageProps) => {
  const { classes: teceoClasses } = useTeceoStyles();
  const { classes: styles } = useFileMessagesStyles();

  if (!isFileMessageType(message)) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        alignItems: isMessageOfUser ? 'flex-end' : 'flex-start',
      }}
    >
      {message.data.urlAndNames.map((urlAndName) => (
        <ButtonBase
          key={urlAndName.name}
          className={styles.button}
          onClick={() => openLinkInNewTab(urlAndName.url)}
        >
          <TextMessage
            hasError={false}
            isSending={false}
            isMessageOfUser={isMessageOfUser}
            message={
              <Box
                sx={{
                  display: 'flex',
                  gap: '4px',
                  alignItems: 'center',
                }}
              >
                <DocumentIcon style={{ color: isMessageOfUser ? 'white' : '#656565' }} />

                <Typography
                  variant="body2"
                  title={urlAndName.name}
                  className={teceoClasses.truncateOneLine}
                >
                  {urlAndName.name}
                </Typography>
              </Box>
            }
          />
        </ButtonBase>
      ))}
    </Box>
  );
};

export default FileMessage;
